<div class="card card-user" *ngIf="person">
  <div class="image" [ngClass]="imageClass"></div>
  <div class="card-body">
    <div class="user">
      <img
        class="avatar"
        [src]="person.urlImageProfile"
        *ngIf="person.urlImageProfile"
      />
      <img
        class="avatar"
        [src]="
          'assets/images/settings/' +
          ([3, 4].includes(subscriptionId) ? 'mens-' : '') +
          'empty-avatar.png'
        "
        *ngIf="!person.urlImageProfile"
      />
      <img
        class="crown"
        *ngIf="premium"
        src="assets/images/crown.png"
        pTooltip="Assinante premium"
        tooltipPosition="left"
      />
      <h5
        class="influencer"
        *ngIf="influencer"
        [pTooltip]="influencer.description || ''"
      >
        {{ influencer.influencerStatus }} ({{
          influencer.enabled ? 'Ativo' : 'Inativo'
        }})
      </h5>
      <h5 class="title">
        {{ person.name }} {{ person.lastName }}
        <ng-container *ngIf="person.personStatus === 15">(Fraude)</ng-container>
        <i
          class="pi pi-external-link"
          pTooltip="Ver usuário"
          tooltipPosition="bottom"
          *ngIf="showProfileLink"
          (click)="openPersonPage()"
        ></i>
      </h5>
      <a
        class="instagram"
        *ngIf="person.instagram"
        [attr.href]="'https://instagram.com/' + person.instagram"
        pTooltip="Ver instagram"
        tooltipPosition="right"
      >
        <span class="data-link" [class.data-link--mens]="mensMarket"
          >&#64;{{ person.instagram }}</span
        >
        <i class="pi pi-instagram"></i>&nbsp;
      </a>
      <p-button
        severity="secondary"
        size="small"
        styleClass="p-button-xs"
        label="Resetar senha"
        *ngIf="showResetPassword"
        (onClick)="resetPassword()"
      />
      <ng-container *ngxPermissionsOnly="['ROLE_ADMIN', 'ROLE_FINANCIAL']">
        <p-button
          *ngIf="person.personId && person.personStatus !== 15"
          severity="danger"
          size="small"
          styleClass="p-button-xs"
          label="Apontar Fraude"
          icon="pi pi-ban"
          iconPos="left"
          (onClick)="fraudCancellation()"
        ></p-button>
        <p-button
          *ngIf="person.personId && person.personStatus === 15"
          severity="info"
          size="small"
          styleClass="p-button-xs"
          label="Remover bloqueio"
          icon="pi pi-unlock"
          iconPos="left"
          (onClick)="fraudReactivation()"
        ></p-button>
      </ng-container>
    </div>
    <p class="description" *ngIf="person.username">
      <strong>Email:</strong>
      <span [class.facebook]="person.facebookId">
        <a
          class="data-link"
          [class.data-link--mens]="mensMarket"
          type="button"
          (click)="copyToClipboard(person.username || '')"
        >
          {{ person.username }}
          <i class="pi pi-copy"></i>
        </a>
        <i
          *ngIf="person.facebookId"
          pTooltip="Acesso por Facebook"
          tooltipPosition="right"
          class="pi pi-facebook p-button-primary"
        ></i>
      </span>
    </p>
    <p class="description" *ngIf="person.birthday">
      <strong>Aniversário:</strong>
      {{ birthdayAsDate | date: 'dd/MM/yyyy' }}
    </p>
    <p class="description" *ngIf="person.cpf">
      <strong>CPF:</strong>
      <a
        class="data-link"
        [class.data-link--mens]="mensMarket"
        type="button"
        (click)="copyToClipboard(cpfFormatted || '')"
      >
        {{ cpfFormatted }}
        <i class="pi pi-copy"></i>
      </a>
    </p>
    <p class="description badge" [ngStyle]="badgeStyle" *ngIf="person.personId">
      <strong>Jóia:</strong>
      {{ person.badge || 'Sem joia' }}
      <img [src]="person.iconUrl" [alt]="person.badge" *ngIf="person.iconUrl" />
      <small *ngIf="person.glampointsMultiplier">
        (x{{ person.glampointsMultiplier | number: '1.0-2' }})
      </small>
    </p>
    <p
      class="description glam-lover"
      *ngIf="person.glamLover"
      pTooltip="Segmento glam lover (VIP estendido) — fonte: Outsider RFTM (glam_addicts), atualizado nightly após o refresh. É independente da joia Diamante Vermelho e não é editável aqui."
      tooltipPosition="top"
    >
      <span class="glam-lover-chip">✨ glam lover</span>
      <small *ngIf="person.glamLoverAsOf">
        (sync {{ person.glamLoverAsOf | date: 'dd/MM/yyyy' }})
      </small>
    </p>
    <p class="description cupom" *ngIf="person.couponName">
      <span> <strong>Cupom:</strong> {{ person.couponName }} </span>
      <p-button
        severity="danger"
        size="small"
        styleClass="p-button-xs"
        label="Editar cupom"
        icon="pi pi-pencil"
        iconPos="left"
        (onClick)="changeCouponName()"
      ></p-button>
    </p>
    <p *ngIf="influencer?.couponName">
      <span> <strong>Cupom Bflu:</strong> {{ influencer.couponName }} </span>
    </p>
    <p class="description" *ngIf="person.phone">
      <strong>Fone:</strong> {{ phoneFormatted }}
    </p>
    <p class="description" *ngIf="person.dateCreated">
      <strong>Desde:</strong> {{ person.dateCreated | date: 'dd/MM/yyyy' }}
    </p>
    <p
      class="description"
      *ngIf="person.street && person.cityCode && person.stateCode"
    >
      <strong>Endereço:</strong> {{ person.street }} {{ person.streetNumber
      }}<span *ngIf="person.streetExtensions?.length"
        >, {{ person.streetExtensions }}</span
      >
      - {{ person.neighborhood }}, {{ person.city }} - {{ person.state }},
      Brasil, CEP
      {{ person.postalCode }}
    </p>
  </div>
</div>
<p-toast />
<p-confirmDialog [style]="{ width: '50vw' }" />
<p-dialog
  [visible]="passwordResult !== undefined"
  [style]="{ width: '50vw' }"
  [draggable]="false"
  [resizable]="false"
  [modal]="true"
  [closable]="false"
  styleClass="password-result"
>
  <ng-template pTemplate="header">
    <span class="p-dialog-title"> Senha alterada </span>
    <p-button
      icon="pi pi-times"
      [rounded]="true"
      styleClass=""
      size="small"
      [text]="true"
      (click)="hideMessage()"
    ></p-button>
  </ng-template>
  <ng-template pTemplate="content">
    <p>
      Nova senha gerada: <strong>{{ passwordResult?.password }}</strong>
    </p>
    <p>{{ passwordResult?.message }}</p>
  </ng-template>
</p-dialog>
